
export function isValidNumber(number) {
  return /^[0-9,\s.-]+$/.test(number);

}